import { DateInput } from "@/lib/Components/Form/Inputs/DateInput";
import { WaitlistLocationInput } from "@/app/Waitlists/Components/WaitlistLocationInput";
import { FormDivider } from "@/lib/Components/Form/Components/FormDivider";
import { RegionInput } from "@/app/Common/Components/RegionInput";
import type { WaitlistInput } from "@/app/Waitlists/Components/WaitlistCreateDialog";
import { AllUserInput } from "@/app/Users/Components/AllUserInput";
import { VehicleCategoryInput } from "@/app/Vehicles/Components/VehicleCategoryInput";
import { NumberInput } from "@/lib/Components/Form/Inputs/NumberInput";
import { useFormikContext } from "formik";

export function WaitlistForm() {
  const { values, initialValues } = useFormikContext<WaitlistInput>();

  return (
    <>
      {!initialValues.user_id ? (
        <AllUserInput name="user_id" label="User" />
      ) : null}

      <RegionInput label="Region" name="region" />

      <FormDivider />

      <DateInput
        name={"earliest_departure_date"}
        label={"Earliest departure date"}
      />
      <DateInput
        name={"latest_departure_date"}
        label={"Latest departure date"}
      />

      <div className="col-span-6" />

      {values.region ? (
        <>
          <WaitlistLocationInput
            className="col-span-6"
            name="departure_location"
            label="Depart from"
            region={values.region}
          />
          <WaitlistLocationInput
            className="col-span-6"
            name="delivery_location"
            label="Deliver to"
            region={values.region}
          />
        </>
      ) : null}

      <FormDivider />

      <VehicleCategoryInput label="Vehicle category" name="vehicle_category" />
      <NumberInput name="number_of_travellers" label="Number of travellers" />
    </>
  );
}
